import findIndex from 'lodash/findIndex';
import omit from 'lodash/omit';
import uniqBy from 'lodash/uniqBy';

import { IMessagesReducer, MessagesActions, MessagesActionsEnum } from 'store/reducers/messagesReducer/messagesTypes';
import { immutableSet } from 'utils/immutableSet';
import { ECommonActions } from 'store/reducers/types';

const initialState: IMessagesReducer = {
  isConnected: false,
  isLoggedInChat: false,
  unreadList: {},
  chats: {
    isCanUpdate: false,
    isNeedUpdate: true,
    list: [],
  },
  activeChat: {
    id: '',
    isTyping: false,
    isCanUpdate: false,
    messages: [],
  },
};

export default function(state = initialState, action: MessagesActions): IMessagesReducer {
  switch (action.type) {
    case MessagesActionsEnum.SetChatStatus:
    case MessagesActionsEnum.GetUnreadCountMessages: {
      return { ...state, ...action.payload };
    }

    case MessagesActionsEnum.GetChatsList: {
      const { list, isCanUpdate } = action.payload;

      return {
        ...state,
        chats: {
          ...state.chats,
          isCanUpdate,
          isNeedUpdate: false,
          // @ts-ignore
          list: uniqBy([...state.chats.list, ...list], 'conversationId'),
        },
      };
    }

    case MessagesActionsEnum.GetActiveMessages: {
      const { messages, isCanUpdate } = action.payload;

      return {
        ...state,
        activeChat: {
          ...state.activeChat,
          isCanUpdate,
          messages: [...messages, ...state.activeChat.messages],
        },
      };
    }

    case MessagesActionsEnum.SetActiveChatId: {
      const { id } = action.payload;

      return {
        ...state,
        unreadList: omit(state.unreadList, id),
        activeChat: { ...initialState.activeChat, id },
      };
    }

    case MessagesActionsEnum.SetIsTypingUser: {
      return { ...state, activeChat: { ...state.activeChat, ...action.payload } };
    }

    case MessagesActionsEnum.SendMessage: {
      // @ts-ignore
      const chatIndex = findIndex(state.chats.list, ['conversationWith.uid', action.payload?.getReceiverId()]);

      return {
        ...state,
        activeChat: {
          ...state.activeChat,
          messages: [...state.activeChat.messages, action.payload],
        },
        chats: {
          ...state.chats,
          list: immutableSet(
            state.chats.list,
            chatIndex,
            { ...state.chats.list[chatIndex], lastMessage: action.payload },
          ),
        },
      };
    }

    case MessagesActionsEnum.GetMessage: {
      const { message: lastMessage, newChat, userId } = action.payload;
      const { activeChat, chats } = state;

      // @ts-ignore
      const chatIndex = findIndex(state.chats.list, ['conversationWith.uid', userId]);
      const messages = userId === state.activeChat.id ? [...activeChat.messages, lastMessage] : activeChat.messages;
      const list = chatIndex >= 0
        ? immutableSet(chats.list, chatIndex, { ...chats.list[chatIndex], lastMessage })
        : [newChat, ...chats.list];

      return {
        ...state,
        activeChat: { ...activeChat, messages },
        chats: { ...chats, list },
      };
    }

    case MessagesActionsEnum.SetIsOnlineUser: {
      return { ...state, chats: { ...state.chats, ...action.payload } };
    }

    case MessagesActionsEnum.SetMessageRead: {
      // @ts-ignore
      const chatIndex = findIndex(state.chats.list, ['conversationWith.uid', action.payload.getSender().getUid()]);
      const chat = state.chats.list[chatIndex];

      // @ts-ignore
      if (chat?.lastMessage.id === action.payload.getMessageId()) {
        return {
          ...state,
          chats: {
            ...state.chats,
            list: immutableSet(
              state.chats.list,
              chatIndex,
              // @ts-ignore
              { ...chat, lastMessage: { ...chat.lastMessage, ...action.payload } },
            ),
          },
        };
      }

      return { ...state };
    }

    case MessagesActionsEnum.AddChat: {
      const { id, list } = action.payload;

      return {
        ...state,
        chats: { ...state.chats, list },
        activeChat: { ...state.activeChat, id },
      };
    }

    case ECommonActions.CleanStore:
    case MessagesActionsEnum.ResetMessagesStore: {
      return initialState;
    }

    default:
      return state;
  }
}
